"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FaBolt, FaChevronDown } from "react-icons/fa6";
import { cx } from "@/lib/tailwind-utils";
import { type ToolCallStatus, classifyToolCall, formatToolResultMessage, friendlyToolName, statusIconColor } from "@/lib/tool-call-format";
import { ToolCallSummary } from "@/types/call";
interface MessageToolResultProps {
  toolCalls: ToolCallSummary[];
  size?: "sm" | "lg";
}
function ToolResultDetails(t0) {
  const $ = _c(4);
  const {
    result
  } = t0;
  let t1;
  if ($[0] !== result) {
    t1 = formatToolResultMessage(result);
    $[0] = result;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const message = t1;
  if (!message) {
    return null;
  }
  let t2;
  if ($[2] !== message) {
    t2 = <div className="mt-1 text-foreground-muted">{message}</div>;
    $[2] = message;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function ToolCallItem(t0) {
  const $ = _c(13);
  const {
    toolCall,
    showName
  } = t0;
  let t1;
  let t2;
  if ($[0] !== showName || $[1] !== toolCall) {
    const status = classifyToolCall(toolCall);
    t1 = "space-y-0.5";
    t2 = showName && <div className="flex items-center gap-1.5"><FaBolt className={cx("h-2.5 w-2.5 shrink-0", statusIconColor(status))} /><span className="font-medium">{friendlyToolName(toolCall.toolName)}</span>{status === "failed" && <span className="text-status-error-text">(Failed)</span>}</div>;
    $[0] = showName;
    $[1] = toolCall;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== toolCall.toolCallDescription) {
    t3 = toolCall.toolCallDescription && <p className="text-foreground-muted">{toolCall.toolCallDescription}</p>;
    $[4] = toolCall.toolCallDescription;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== toolCall.result) {
    t4 = <ToolResultDetails result={toolCall.result} />;
    $[6] = toolCall.result;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export function MessageToolResult(t0) {
  const $ = _c(45);
  const {
    toolCalls,
    size: t1
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const [isExpanded, setIsExpanded] = useState(false);
  const statuses = toolCalls.map(classifyToolCall);
  const headerStatus = statuses.includes("failed") ? "failed" : statuses.includes("unknown") ? "unknown" : "success";
  const isMultiple = toolCalls.length > 1;
  let t2;
  if ($[0] !== isMultiple || $[1] !== toolCalls[0] || $[2] !== toolCalls.length) {
    t2 = isMultiple ? `${toolCalls.length} AI actions` : friendlyToolName(toolCalls[0].toolName);
    $[0] = isMultiple;
    $[1] = toolCalls[0];
    $[2] = toolCalls.length;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const summaryText = t2;
  const t3 = size === "sm" ? "-mt-1.5" : "-mt-3";
  let t4;
  if ($[4] !== t3) {
    t4 = cx("ml-auto w-fit max-w-[min(70%,500px)]", t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = size === "sm" ? "px-2.5 py-1 text-caption" : "px-3 py-1.5 text-body";
  let t6;
  if ($[6] !== t5) {
    t6 = cx("rounded-xl border border-border bg-background-secondary/50 backdrop-blur-sm", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  let t8;
  if ($[8] !== isExpanded) {
    t7 = () => setIsExpanded(!isExpanded);
    t8 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setIsExpanded(!isExpanded);
      }
    };
    $[8] = isExpanded;
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== headerStatus || $[12] !== size) {
    t9 = cx("shrink-0", statusIconColor(headerStatus), size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3");
    $[11] = headerStatus;
    $[12] = size;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <FaBolt className={t9} />;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== summaryText) {
    t11 = <span className="font-medium truncate">{summaryText}</span>;
    $[16] = summaryText;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== headerStatus || $[19] !== isMultiple) {
    t12 = headerStatus === "failed" && !isMultiple && <span className="shrink-0 text-status-error-text">(Failed)</span>;
    $[18] = headerStatus;
    $[19] = isMultiple;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="shrink-0 text-foreground-muted italic">· not visible to patient</span>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = size === "sm" ? "h-2 w-2" : "h-2.5 w-2.5";
  const t15 = isExpanded && "rotate-180";
  let t16;
  if ($[22] !== t14 || $[23] !== t15) {
    t16 = cx("ml-auto shrink-0 transition-transform", t14, t15);
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t16) {
    t17 = <FaChevronDown className={t16} />;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t12 || $[30] !== t17 || $[31] !== t7 || $[32] !== t8) {
    t18 = <div role="button" tabIndex={0} onClick={t7} onKeyDown={t8} className="flex w-full items-center gap-1.5 text-foreground-secondary hover:text-foreground transition-colors cursor-pointer">{t10}{t11}{t12}{t13}{t17}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
    $[30] = t17;
    $[31] = t7;
    $[32] = t8;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== isExpanded || $[35] !== isMultiple || $[36] !== toolCalls) {
    t19 = isExpanded && <div className="mt-1.5 border-t border-border pt-1.5 space-y-2">{toolCalls.map(toolCall => <ToolCallItem key={toolCall.id} toolCall={toolCall} showName={isMultiple} />)}</div>;
    $[34] = isExpanded;
    $[35] = isMultiple;
    $[36] = toolCalls;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t18 || $[39] !== t19 || $[40] !== t6) {
    t20 = <div className={t6}>{t18}{t19}</div>;
    $[38] = t18;
    $[39] = t19;
    $[40] = t6;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t20 || $[43] !== t4) {
    t21 = <div className={t4}>{t20}</div>;
    $[42] = t20;
    $[43] = t4;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  return t21;
}